import { BaseList } from "App/Screens/SubModules/Component";
import descriptor from "./descriptorOffline";

class MerchantPricing extends BaseList {
  constructor(props) {
    super(props)

    this.appName = 'jobs'
    this.modelName = 'merchantpricing'
    this.availablePermissions = ['.view_']
    this.propsList = {
      avatar: 'merchant.name',
      pageTitle: 'Merchant Pricing',
      descriptor,
      masterKey: 'module-merchant-pricing',
    }
    this.state = {
      ...this.state,
      currentPermissionSet: this.isSuperuser ? this.availablePermissions : [],
    }
  }
}

export default MerchantPricing